const moduleRoute = {
  path: '/mudar-unidade',
  component: () => import('./views/UnityToggle.vue'),
  meta: { requiresAuth: true }
}

export default router => {
  router.addRoute(moduleRoute)
}
